"use client"

import { useState, useEffect } from "react"
import { ExternalLink } from "lucide-react"

const SponsorBanner = ({ page = "home" }) => {
  const [currentSponsor, setCurrentSponsor] = useState(0)

  const sponsors = {
    home: [
      {
        name: "Ethiopian Airlines",
        logo: "/assets/images/airlines.png",
        tagline: "Africa's Largest Aviation Group",
        description: "Connecting Africa to the world with excellence in aviation services.",
        website: "https://www.ethiopianairlines.com/",
        category: "Aviation",
      },
      {
        name: "Ethiopian Maritime Authority",
        logo: "/assets/images/ema.png",
        tagline: "Leading Maritime Excellence",
        description: "Regulating and promoting Ethiopia's maritime industry development.",
        website: "https://etmaritime.com/",
        category: "Maritime",
      },
      {
        name: "EMA Marine ",
        logo: "/assets/images/EMA_logo.png",
        tagline: "Global Maritime Solutions",
        description: "Providing comprehensive maritime services and crew management.",
        website: "https://www.emacrew.com/",
        category: "Marine Services",
      },
    ],
    about: [
      {
        name: "Ministry of Transport & Logistics",
        logo: "/assets/images/MoTL.jpg",
        tagline: "Building Ethiopia's Future",
        description: "Developing transportation infrastructure and logistics policies.",
        website: "https://www.motl.gov.et/",
        category: "Government",
      },
      {
        name: "Ethiopian Maritime Training Institute",
        logo: "/assets/images/emtisc.jpg",
        tagline: "Training Tomorrow's Leaders",
        description: "World-class maritime education and professional training programs.",
        website: "https://emticorp.com/",
        category: "Education",
      },
    ],
  }

  const currentSponsors = sponsors[page] || sponsors.home

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSponsor((prev) => (prev + 1) % currentSponsors.length)
    }, 8000) // Change every 8 seconds

    return () => clearInterval(interval)
  }, [currentSponsors.length])

  const sponsor = currentSponsors[currentSponsor]

  return (
    <div className="bg-white border-4 border-blue-200 rounded-xl shadow-2xl w-full transform hover:scale-105 transition-all duration-300">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-800 px-3 py-2 border-b border-blue-300 rounded-t-lg">
        <h3 className="text-sm sm:text-base font-bold text-white uppercase tracking-wide text-center">
          ✨ FEATURED SPONSOR ✨
        </h3>
      </div>

      {/* Content */}
      <div className="p-4 sm:p-6">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex-shrink-0 w-full flex justify-center">
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 px-6 rounded-xl border-2 border-gray-200 shadow-inner">
              <img
                src={sponsor.logo || "/placeholder.svg"}
                alt={sponsor.name}
                className="h-26 w-26 sm:h-28 sm:w-28 object-contain"
                onError={(e) => {
                  e.target.src = "/placeholder.svg?height=128&width=128"
                }}
              />
            </div>
          </div>

          <div className="flex-1 min-w-0 text-center">
            <h4 className="text-xl sm:text-xl font-bold text-gray-900 mb-2 leading-tight">{sponsor.name}</h4>
            <p className="text-base sm:text-md text-blue-700 font-bold mb-3 leading-tight">{sponsor.tagline}</p>
            <p className="text-sm sm:text- text-sm  text-gray-800 font-medium leading-relaxed mb-4 line-clamp-3">
              {sponsor.description}
            </p>

            <div className="flex flex-col items-center space-y-3">
              <span className="inline-block text-sm bg-gradient-to-r from-blue-100 to-blue-200 text-blue-900 text-sm font-bold px-4 py-1 rounded-full border border-blue-300">
                Category: {sponsor.category}
              </span>
              <a
                href={sponsor.website}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-sm sm:text-base text-white font-bold bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 px-6 py-3 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                Visit Website
                <ExternalLink className="h-4 w-4 ml-2" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Progress indicator */}
      <div className="px-4 pb-4 sm:px-6 sm:pb-6">
        <div className="flex space-x-2">
          {currentSponsors.map((_, index) => (
            <div
              key={index}
              className={`h-3 flex-1 rounded-full transition-all duration-500 ${
                index === currentSponsor ? "bg-gradient-to-r from-blue-500 to-blue-600 shadow-md" : "bg-gray-300"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default SponsorBanner
